import { Component, OnInit, ViewChild, HostListener, Inject } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatStepper } from '@angular/material/stepper';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GlobalService } from '../../services/global.service';
import { MlModel } from '../mlmodel/mlModel.model';
import { UOMData } from '../../../assets/UOMDataTs';
import { ModelParameter } from '../mlmodel/mlModel-parameters.model';
import { MLService } from '../../services/ml-service';
import { Globals } from '../globals.model';
import { TenantService } from '../../services/tenant.service';
import { AlertComponent } from '../../common/alert/alert.component';
import { HttpService } from 'src/app/services/http.service';

@Component({
  selector: 'app-model-registration',
  templateUrl: './model-registration.component.html',
  styleUrls: ['./model-registration.component.css']
})
export class ModelRegistrationComponent implements OnInit {
  stepOne = true;
  stepTwo = false;
  stepThree = false;
  activModelName = 'Physics Based';
  availableModelName: string = '';
  modelDetails: any;
  fileToUpload: File = null;
  imageToUpload: File = null;
  registrationName = '';
  modelApiVersion = '';
  description = '';
  modelId = 0;
  businessFunction: any = { businessFunctionTypeId: 0, businessFunctionTypeName: '' };
  physicsBasedType: any = { baseModelId: 0, baseModelName: "" };
  selectedFileName = '';
  selectedImageName = '';
  availalbleModel: any = { registrationName: '' };
  availalbleModelVersion: any = { modelConfigrationId: '' };
  isPhysicsDisabled = true;
  isAdvanceDisabled = true;
  isCreMsg = false;
  apiRegModErr: string;
  isModelReg = true;
  modRegErrMsg: string;
  isCreateErrorApp = false;
  createErrorMessage = 'Message';
  isModelServiceCreate = true;
  modelErrCreateMsg = '';
  isCreErrorAPI = false;
  creModMessage: string;
  selectedText = 'Selected';
  isErrInCon = true;
  conErrMsg = 'Error';
  isErrDel = true;
  modDelErr = '';
  isViewErr = true;
  viewErrMsg = '';
  isVertical: boolean = false;
  regProgress = false;
  errorInModelCreation = '';
  modelParamsErro = '';
  availModelErro = '';
  isLoading = false;
  availModelList = [];
  modelListOptions = [];
  regErrorMsg = false;
  businessFunctionTypesList = [];
  availModelVersionList = [];
  baseModelTypesList = [];
  isPhysicsBasedType = true;
  selectedStep = 0;
  activeParam: number = 0;
  isInputParameters = true;
  captionExist = true;
  dupCapInParam = [];
  dupCapOutParam = [];
  validCapInParam = [];
  validCapOutParam = [];
  selectedModelName = "";
  selectedModelVersion = "";
  selectedModelType = "";
  noInputOutputParam = "";
  uomMap: Array<any>;
  uomType: string;
  uomTypes: string[];
  result: any;
  uom: string;
  uoms: string[];
  modelData = new MlModel();
  invalidStepTwo = false;
  invalidModelAndVersion = false;
  isUOMDisabled = true;
  checkUOMTypeChanged: boolean = true;
  previousInputUOMType = null;
  previousOutputUOMType = null;
  masterData: any;
  filteredMasterData: any;
  @ViewChild('f', { static: true }) registerForm: NgForm;
  @ViewChild('stepper', { static: false }) stepper: MatStepper;
  @HostListener('window:resize') onWindowResize() {
    if (window.innerWidth <= 768) {
      this.isVertical = true;
    } else { this.isVertical = false; }
  }
  newImageUploaded: boolean = false;
  constructor(
    public httpService: HttpService,
    public dialogRef: MatDialogRef<ModelRegistrationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public httpClient: HttpClient,
    private readonly globals: GlobalService,
    public globalsConfig: Globals,
    public tenantService: TenantService,
    public mlService: MLService) { }

  ngOnInit() {
    this.regProgress = true;
    this.mlService.getToken().subscribe((data: any): void => {
      this.uomTypes = Object.keys(UOMData);
      this.uomMap = Object.keys(UOMData).map(key => ({ type: key, value: UOMData[key] }));
      this.getBusinessFunctionTypes();
      this.handleFileInput();
      this.getListofModel();
    });
  }

  configureIt(uomType, index) {
    this.activeParam = index;
    this.populateUOM(uomType);
  }

  stepChange(event) {
    let stepLabel = event.selectedStep.label;
    this.activeParam = 0;
    if (stepLabel == "configuration"
      && (this.selectedModelName !== JSON.stringify(this.registrationName)
        || this.selectedModelType !== JSON.stringify(this.activModelName))) {
      this.selectedModelName = JSON.stringify(this.registrationName);
      this.selectedModelVersion = JSON.stringify(this.modelApiVersion);
      this.selectedModelType = JSON.stringify(this.activModelName);
      this.getParameters();
    }
  }

  filterSelectedParames(params) {
    params.filter(
      (item) =>
        Object.keys(item).includes('captionName') &&
        Object.keys(item).includes('parameterUom')
    );
  }

  getParameters() {
    this.invalidStepTwo = false;
    this.modelParamsErro = '';
    this.mlService.getParameterList(this.availalbleModel.registrationName, this.availalbleModelVersion.modelConfigrationId).subscribe((data: any): void => {
      this.modelData.inputParameters = data.inputParamters;
      this.modelData.outputParameters = data.outputParamters;
      if (data.inputParamters.length !== 0 && data.outputParamters !== 0) {
        this.noInputOutputParam = "";
        if (this.data.selectedData) {
          this.getConfigParams(this.data.selectedData.modelId);
        } else {
          this.regProgress = false;
        }
      } else {
        this.invalidStepTwo = true;
        if (this.data.selectedData) {
          this.noInputOutputParam = "Input and output parameters not available for " + this.data.selectedData.registrationName + " model";
        }
      }
    }, (error: Error) => {
      this.handleErrorScenario();
    });
  }

  getListofModel() {
    this.mlService.getModelList().subscribe((data: any): void => {
      if (data && data !== null && data.length > 0) {
        this.masterData = [...data];
        this.isLoading = false;
      }
      this.isLoading = false;
    }, (error: Error) => {
      this.globals.showAlert(AlertComponent, { success: false, message: "Error in fetching model repository" });
      this.isLoading = false;
    });
  }

  handleErrorScenario() {
    this.invalidStepTwo = true;
    if (this.data.selectedData) {
      this.modelParamsErro = "Error in getting parameters list for " + this.data.selectedData.registrationName + " model";
    }
    this.regProgress = false;
  }

  // populate values in second dropdown on selection of value in first
  populateUOM(uomType) {
    this.isUOMDisabled = false
    const _self = this;
    if (this.uomMap && this.uomMap.length > 0) {
      _self.result = this.uomMap.filter((u) => {
        if (uomType === u.type) {
          _self.uoms = u.value;
        }
      });
    }
  }

  resetUOM(index, parameterType: string) {
    this.captionExist = false;
    if (parameterType === "inputParameters") {
      this.modelData.inputParameters[index].parameterUom = '';
    } else if (parameterType === "outputParameters") {
      this.modelData.outputParameters[index].parameterUom = '';
    }
  }

  resetUOMType(index, event, parameterType: string) {
    this.checkUOMTypeChanged = true;
    if (parameterType === "inputParameters") {
      this.previousInputUOMType = this.modelData.inputParameters[index].parameterUom;
      this.modelData.inputParameters[index].parameterUom = event;
    }
    else if (parameterType === "outputParameters") {
      this.previousOutputUOMType = this.modelData.outputParameters[index].parameterUom;
      this.modelData.outputParameters[index].parameterUom = event;
    }

    if (this.previousInputUOMType !== this.modelData.inputParameters[index].parameterUom
      || this.previousOutputUOMType !== this.modelData.outputParameters[index].parameterUom) {
      this.checkUOMTypeChanged = false;
      this.captionExist = false;
    }
  }

  setBaseModelName(baseModelIdNumber) {
    if (baseModelIdNumber == 1) {
      return "Compiled";
    };
    return baseModelIdNumber == 2 ? "Surrogate" : "Simulation";
  }

  getConfigParams(modelId) {
    this.mlService.getConfigParameter(modelId).subscribe((data: any): void => {
      let baseModelIdNumber = this.availalbleModel.baseModelId;
      let baseModelIdName = this.setBaseModelName(baseModelIdNumber);
      if (baseModelIdName !== "Simulation") {
        this.modelData.inputParameters = data.inputParameters;
        this.modelData.outputParameters = data.outputParameters;
      } else {
        this.modelData.inputParameters = this.updateConfigParams(this.modelData.inputParameters, data.inputParameters)
        this.modelData.outputParameters = this.updateConfigParams(this.modelData.outputParameters, data.outputParameters);
      }
      if (this.modelData.inputParameters.length > 0) {
        this.populateUOM(this.modelData.inputParameters[0].uomType);
      }
      this.regProgress = false;
    }, (error: Error) => {
      this.handleErrorScenario();
    });
  }

  updateConfigParams(rawParam, configParam) {
    for (let i = 0; i < rawParam.length; i++) {
      for (const element of configParam) {
        if (rawParam[i].parameterId === element.parameterId) {
          rawParam[i] = element;
        }
      }
    }
    return rawParam;
  }

  checkIfEdit(dataForEdit) {
    if (dataForEdit.selectedData) {
      this.activModelName = (dataForEdit.selectedData.modelTypeName).trim();
      this.modelId = dataForEdit.selectedData.modelId;
      this.physicsBasedType = this.baseModelTypesList.find(x => x.baseModelId == dataForEdit.selectedData.baseModelId);
      this.isPhysicsBasedType = (this.activModelName == 'Physics Based') ? true : false;
      this.isPhysicsDisabled = false;
      this.isAdvanceDisabled = false;
      if (this.isPhysicsBasedType) {
        this.isPhysicsDisabled = true
      }
      else { this.isAdvanceDisabled = true };

      this.getAvailableModel(this.activModelName, this.setAvailableModel, dataForEdit.selectedData.modelConfigrationId, dataForEdit.selectedData.registrationName, 'viewEdit');
      this.registrationName = (dataForEdit.selectedData.modelName).trim();
      this.modelListOptions = [];
      this.modelListOptions.push(dataForEdit.selectedData);
      this.availalbleModel = {registrationName: dataForEdit.selectedData.registrationName};
      this.availalbleModelVersion = dataForEdit.selectedData.modelConfigrationId;
      this.description = dataForEdit.selectedData.businessDescription;
      this.businessFunction = this.businessFunctionTypesList.find(x => x.businessFunctionTypeName == (dataForEdit.selectedData.businessFunctionTypeName).trim());
    } else {
      this.activModelName = 'Physics Based';
      this.getAvailableModel(this.activModelName, null, null, null, null);
      this.regProgress = false;
    }
  }

  setAvailableModel(availalbleModel, modelConfigrationId, thisRef: ModelRegistrationComponent) {
    thisRef.availalbleModel = thisRef.availModelList.find(m => m.registrationName == availalbleModel && m.modelConfigrationId == modelConfigrationId);
    thisRef.availalbleModelVersion = thisRef.availModelVersionList.find(m => m.modelConfigrationId == modelConfigrationId);
  }

  /**When Reg. Name focused */
  resetNameValid() {
    if (this.regErrorMsg) {
      this.regErrorMsg = false;
    }
  }

  chkNameValid() {
    if (this.registrationName === '') {
      this.regErrorMsg = true;
    } else {
      this.regErrorMsg = false;
    }
  }

  /**When Model is selected */
  onModelSelected(item) {
    this.availModelVersionList = [];
    this.registrationName = item.registrationName;

    this.mlService.getModelConfigurationData().subscribe((data: any) => {
      if (data.length > 0) {
        let response = data;
        const matchedModel = response.filter(element => element.type == item.type);
        this.availModelVersionList = matchedModel.filter(a => a.registrationName === item.registrationName);
      }
    });
  }

  onVersionSelected(item) {
    if (this.masterData != null) {
      let modelDetails = this.masterData.find(a => a.modelConfigrationId == item.modelConfigrationId && a.registrationName == item.registrationName);
      this.filteredMasterData = modelDetails;
      if (this.filteredMasterData === undefined) {
        this.invalidModelAndVersion = false;
      }
      else {
        this.invalidModelAndVersion = true;
      }
    }
    let matchedBaseModel = this.baseModelTypesList.find(e => e.baseModelId === item.baseModelId);
    this.physicsBasedType = matchedBaseModel;
    this.availalbleModel.url = item.url;
    this.availalbleModel.modelVersion = item.modelVersion;
    this.availalbleModel.modelConfigrationId = item.modelConfigrationId;
    this.registrationName = item.registrationName + '-' + item.modelVersion;
  }

  getAvailableModel(selecteModelType, methodRef: (data: any, modelConfigrationId: any, thisRef: any) => void, modelConfigrationId, availalbleModel, viewEdit) {
    this.availModelList = [];
    this.availModelErro = '';
    this.regProgress = true;

    this.mlService.getModelConfigurationData().subscribe((data: any) => {
      if (data.length > 0) {
        let response = data;
        const matchedModel = response.filter(element => element.type == selecteModelType);
        const modelList = matchedModel.filter((value, index, self) =>
          index === self.findIndex((t) => (
            t.registrationName === value.registrationName
          ))
        );
        this.modelListOptions = viewEdit ? matchedModel : [... new Set(modelList)];
        
        this.availModelList = matchedModel;
        this.availModelVersionList = this.availModelList.filter(a => a.registrationName === availalbleModel);
        this.regProgress = false;
        if (methodRef != null) {
          methodRef(availalbleModel, modelConfigrationId, this);
        }
      }
      else{
        this.globals.showAlert(AlertComponent, { success: false, message: "Kindly configure minimum one Model to continue with registration." });
        this.regProgress = false;
      }
    }, (error: Error) => {
      this.globals.showAlert(AlertComponent, { success: false, message: "Error in fetching model repository!" });
      this.regProgress = false;
    });
  }

  selectionChange(selelctedStep) {
    this.selectedStep = selelctedStep;
  }

  selectParamType(paramType, inputTabSelected) {
    if (inputTabSelected !== this.isInputParameters) {
      this.activeParam = 0;
    }
    if (paramType === 'input') {
      this.populateUOM(this.modelData.inputParameters[0].uomType);
      this.isInputParameters = true;
    } else {
      this.populateUOM(this.modelData.outputParameters[0].uomType);
      this.isInputParameters = false;
    }
  }

  getBusinessFunctionTypes() {
    this.businessFunctionTypesList = [];
    this.regProgress = true;
    this.mlService.getBusinessFunctionTypes().subscribe((data: any): void => {
      if (data.length > 0) {
        this.businessFunctionTypesList = data;
      }
      this.getBaseModelTypes();
    }, (error: Error) => {
      this.regProgress = false;
    });
  }

  getBaseModelTypes() {
    this.mlService.getBaseModelTypes().subscribe((data: any): void => {
      if (data.length > 0) {
        this.baseModelTypesList = data;
      }
      this.checkIfEdit(this.data);
    }, (error: Error) => {
      this.regProgress = false;
    });
  }

  modefiedList(dataset) {
    let modefiedList = [];
    const listDataModel = dataset;
    for (const element of listDataModel) {
      if (element.properties.method === "POST") {
        modefiedList.push(element);
      }
    }
    return modefiedList;
  }

  handleFileInput() {
    const blob = new Blob([''], { type: 'text/html' });
    blob['lastModifiedDate'] = Date.now();
    blob['name'] = 'filename.png';
    const file = <File>blob;
    this.fileToUpload = file;
    this.selectedFileName = this.fileToUpload.name;
  }

  handleModelImageInput(imageFile: File) {
    this.imageToUpload = imageFile;
    this.selectedImageName = this.imageToUpload.name;
    this.captionExist = false;
    this.invalidStepTwo = false;
    this.isUOMDisabled = false;
    this.checkUOMTypeChanged = false;
  }

  onSubmit() {
    this.regProgress = true;
    let modifiedTime: any = new Date().toISOString();
    this.modelData.modelId = this.modelId;
    this.modelData.modelName = this.registrationName;
    this.modelData.businessDescription = this.description;
    this.modelData.modelType = this.activModelName;
    this.modelData.baseModelId = this.availalbleModel.baseModelId;
    this.modelData.businessFunctionType = this.businessFunction.businessFunctionTypeId;
    this.modelData.lastUpdatedDate = modifiedTime;
    this.modelData.createdBy = this.globals.loggedInUser;
    this.modelData.lastUpdatedBy = this.globals.loggedInUser;
    this.modelData.refineryName = this.tenantService.getCurrentTenant().tenantRefinery;
    this.modelData.modelEntityType = 'Basic';
    this.modelData.apiUrl = this.availalbleModel.url;
    this.modelData.modelConfigrationId = this.availalbleModel.modelConfigrationId;
    this.modelData.tenantId = this.tenantService.getCurrentTenant().tenantId;
    let baseModelIdNumber = this.availalbleModel.baseModelId;
    let baseModelIdName = this.setBaseModelName(baseModelIdNumber);
    if (baseModelIdName == "Simulation") {
      this.filterSelectedParames(this.modelData.inputParameters);
      this.filterSelectedParames(this.modelData.outputParameters);
    }
    this.SyncModelDataInRepo();
  }

  //map input and output parameters and sync in database
  SyncModelDataInRepo() {
    //Generate form data for save post call
    const formData: FormData = new FormData();
    formData.set('data', JSON.stringify(this.modelData));
    if (this.imageToUpload != null) {
      formData.set('modelImage', this.imageToUpload, this.imageToUpload.name);
    }

    this.saveModelMasterData(this, formData);
  }

  saveModelMasterData(thisRef: ModelRegistrationComponent, formData: FormData) {
    thisRef.mlService.saveModelMasterData(formData).subscribe((result: any): void => {
      thisRef.regProgress = false;
      thisRef.globals.showAlert(AlertComponent, { success: true, message: "Model added succesfully!" });
      thisRef.dialogRef.close('added');
    }, (error: Error) => { thisRef.badResponse('Something went wrong while synching Model data.'); });
  }

  checkEmptyInputOrOutputParameters(modelData) {
    let checkEmptyInputParameters = this.modelData.inputParameters.find((val) => {
      return val.captionName === '' || val.parameterUom === '';
    });
    let checkEmptyOnputParameters = this.modelData.outputParameters.find((val) => {
      return val.captionName === '' || val.parameterUom === '';
    });
    return checkEmptyInputParameters || checkEmptyOnputParameters;
  }

  checkValidParam() {
    let baseModelIdNumber = this.availalbleModel.baseModelId;
    let baseModelIdName = this.setBaseModelName(baseModelIdNumber);
    if (baseModelIdName !== "Simulation") {
      return (this.modelData.inputParameters.findIndex((p, index) => !p.captionName || !p.parameterUom || this.dupCapInParam[index]) > -1
        || this.modelData.outputParameters.findIndex(p => !p.captionName || !p.parameterUom) > -1);
    } else {
      let inputParamValid = this.modelData.inputParameters.filter((m) => {
        return m.captionName && m.parameterUom;
      });
      let outputParamValid = this.modelData.outputParameters.filter((m) => {
        return m.captionName && m.parameterUom;
      });
      return !(inputParamValid.length > 0 && outputParamValid.length > 0 && (!this.checkEmptyInputOrOutputParameters(this.modelData)));
    }
  }

  validateCaption(event, activeIndex, dupType, nameType, parameters) {
    if (event.target.value) {
      const nameRGEX = new RegExp('^[A-Za-z0-9][A-Za-z0-9_.-]*');
      let latest = event.target.value;
      let nameExisiting;
      let nameValid = true;
      dupType[activeIndex] = false;
      nameType[activeIndex] = false;
      nameExisiting = parameters.filter((m, index) => {
        if (index !== activeIndex) {
          return m.captionName == latest;
        }
      });
      this.captionExist = nameExisiting.length > 0;
      if (!this.captionExist) {
        nameValid = nameRGEX.test(latest);
      }
      this.checkUOMTypeChanged = false;
      nameType[activeIndex] = !nameValid;
      dupType[activeIndex] = nameExisiting.length > 0;
    }
  }

  resetThisParams(params: ModelParameter[], index) {
    params[index].captionName = '';
    params[index].uomType = '';
    params[index].parameterUom = '';
  }

  validateFirstStep() {
    const nameRGEX = new RegExp('^[A-Za-z0-9][A-Za-z0-9_.-]*');
    const nameValid = nameRGEX.test(this.registrationName);
    return (!nameValid || this.invalidModelAndVersion || !this.description || this.businessFunction.businessFunctionTypeId == 0 || this.availalbleModel == '');
  }

  badResponse(errorMasg) { this.errorInModelCreation = errorMasg; this.regProgress = false; }
  onNoClick(this: ModelRegistrationComponent): void {
    this.dialogRef.close(this);
  }
  gotoStepOne(): void {
    this.stepOne = true;
    this.stepTwo = false;
    this.stepThree = false;
  }
  gotoStepTwo(): void {
    this.stepOne = false;
    this.stepTwo = true;
    this.stepThree = false;
  }
  selectModelType(modelTypeName) {
    if (!this.data.selectedData) {
      this.availalbleModel = { registrationName: '' };
      this.availalbleModelVersion = "";
      this.physicsBasedType = { baseModelId: 0, baseModelName: "" };
      this.activModelName = modelTypeName;
      this.getAvailableModel(this.activModelName, this.availalbleModelVersion, null, null, null);
      this.regErrorMsg = false;
      this.isPhysicsBasedType = (this.activModelName == 'Physics Based') ? true : false;
    }
  }

  selectAvailModel(modelItem) {
    this.availableModelName = modelItem;
    this.modelDetails = modelItem;
  }

  errorCreatMsg(msg, error) {
    if (msg === 'create') { this.isCreMsg = true; } else { this.apiRegModErr = msg + error; }
  }
  erroModReg(error) {
    this.isModelReg = false;
    if (error === 'Module') {
      this.modRegErrMsg = 'Error is in modeule, more details: ' + error;
    } else { this.modRegErrMsg = 'Generic error'; }
  }
  errorInCreate(msg, error) {
    this.isCreateErrorApp = true;
    this.createErrorMessage = msg + error;
  }
  erroHandlingCreateSer(msg, error) {
    this.isModelServiceCreate = true;
    if (msg === 'service') {
      this.modelErrCreateMsg = msg + error;
    } else { this.modelErrCreateMsg = msg; }
  }
  erroHandlingCreateAPI(msg, error) {
    if (msg === 'inApi') {
      this.isCreErrorAPI = true;
    } else { this.isCreErrorAPI = false; }
    this.creModMessage = msg + error;
  }
  selectText(newValue) {
    if (newValue === 'Added') { this.selectedText = 'Added ' + newValue; }
    else { this.selectedText = newValue; }
  }
  erroInConn(error) {
    if (error === 'inConnection') {
      this.isErrInCon = false;
      this.conErrMsg = 'Error is: ' + error;
    } else { this.conErrMsg = 'Error is in connection: ' + error; }
  }
  erroCallDel(error) {
    this.isErrDel = false;
    if (error === 'delete') {
      this.modDelErr = 'Error is: ' + error;
    } else { this.modDelErr = 'Error'; }
  }
  erroInViewMod(error) {
    if (error === 'view') {
      this.isViewErr = false;
      this.viewErrMsg = 'Error is: ' + error;
    } else { this.viewErrMsg = 'Error is: '; }
  }
}
